export var adler32 = function (data) {
    var MOD_ADLER = 65521;
    var BITS_MOVED = 16;
    var length = data.length;
    var a = 1;
    var b = 0;
    for (var i = 0; i < length; i++) {
        a += data.charCodeAt(i);
        b += a;
    }
    a %= MOD_ADLER;
    b %= MOD_ADLER;
    return (b << BITS_MOVED) | a;
};
